import { Routes } from '@angular/router'

import { DefaultOrganisationAdminPermissionsGuard } from './organisation-admin.guards'
import { OrgAdminFontsPermissionsResolver } from './organisation-admin.resolvers'

export const OrganisationAdminRoutes: Routes = [
  {
    path: '',
    redirectTo: 'projects',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('@flowx/designer/modules/layout/components/main-layout/main-layout.component').then(
        ({ MainLayoutComponent }) => MainLayoutComponent
      ),
    loadChildren: () =>
      import('./organisation-admin-main-layout-routes').then(
        ({ OrganisationAdminMainLayoutRoutes }) => OrganisationAdminMainLayoutRoutes
      ),
  },
  // Detail pages have no sidebar, like the theme and font pages.
  {
    path: '',
    loadChildren: () =>
      import('./organisation-admin-entity-details-routes').then(
        ({ OrganisationAdminEntityDetailsRoutes }) => OrganisationAdminEntityDetailsRoutes
      ),
  },
  {
    path: 'font-files/:name',
    canActivate: [DefaultOrganisationAdminPermissionsGuard(['org_font_read'])],
    resolve: { permissions: OrgAdminFontsPermissionsResolver },
    loadComponent: () =>
      import('@flowx/designer/modules/cms/pages/font-files/components/font-family/font-family.component').then(
        ({ FlxFontFamilyComponent }) => FlxFontFamilyComponent
      ),
  },
]
